import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Toaster } from "react-hot-toast";
import { Container } from "react-bootstrap";
import HomePage from "./screens/HomePage";
import "./css/App.css"
import Navbar from "./components/NewNavbar";
import Lenis from "lenis";
import { useEffect, useState } from "react";

import Cursor from "./components/Cursor";
import ContactUs from "./screens/ContactUs";
import PageTransition from "./components/PageTransition";
import PageTitle from "./components/PageTitle";
import WhoAreWe from "./screens/WhoAreWe";
import WorkProcess from "./screens/WorkProcess";
import Reference from "./screens/Reference";
import Footer from "./components/Footer";
import Login from "./screens/Login";
import Register from "./screens/Register";
import TopButton from "./components/TopButton";
import TrafficFlow from "./screens/TrafficFlow";
import ErrorPage from "./screens/ErrorPage";
import { getLoggedInUser } from "./axios";
import { logoutAction } from "./actions/authAction";
import { useDispatch } from "react-redux";
import ForgotPassword from "./screens/ForgotPassword";
import ResetPassword from "./screens/ResetPassword";

const App = () => {
  const [user, setUser] = useState(null);

  const dispatch = useDispatch();

  const lenis = new Lenis({
    ignoreSelector: '.nav__menu',
  })

  let animationFrameId;
  let isLenisRunning = true;

  function raf(time) {
    if (isLenisRunning) {
      lenis.raf(time);
      animationFrameId = requestAnimationFrame(raf);
    }
  }

  useEffect(() => {
    animationFrameId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(animationFrameId);
    }
  }, [])

  const lenisStop = () => {
    isLenisRunning = false;
    cancelAnimationFrame(animationFrameId);
  }


  const lenisStart = () => {
    isLenisRunning = true;
    animationFrameId = requestAnimationFrame(raf);
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await getLoggedInUser();
        setUser(response.data)

      } catch (error) {
        setUser(false)
      }
    };
    checkAuth();
  }, []);

  const logout = async () => {
    dispatch(logoutAction(setUser))
  }

  const routes = [
    { path: "/", element: <HomePage /> },
    { path: "/trafik-akisi", element: <TrafficFlow /> },
    { path: "/biz-kimiz", element: <WhoAreWe /> },
    { path: "/surecler", element: <WorkProcess /> },
    { path: "/referanslar", element: <Reference /> },
    { path: "/iletisim", element: <ContactUs /> },
    { path: "*", element: <ErrorPage /> }
  ];

  const [showAppFooter, setShowAppFooter] = useState(true)
  const [showAppNavbar, setShowAppNavbar] = useState(false)

  return (
    <div>
      <Cursor />
      <PageTransition />
      <Router>
        <PageTitle />
        <Navbar lenis={lenis} routes={routes} isLenisRunning={isLenisRunning} showAppNavbar={showAppNavbar} logout={logout} user={user} />
        <main className="">
          <Container>
            <Routes>
              <Route path="/" element={<HomePage />}></Route>
              <Route path="/giris-yap" element={<Login />}></Route>
              <Route path="/sifremi-unuttum" element={<ForgotPassword />}></Route>
              <Route path="/sifremi-sifirla" element={<ResetPassword />}></Route>
              <Route path="/kayit-ol" element={<Register />}></Route>
              <Route path="/biz-kimiz" element={<WhoAreWe />}></Route>
              <Route path="/surecler" element={<WorkProcess />}></Route>
              <Route path="/referanslar" element={<Reference />}></Route>
              <Route path="/iletisim" element={<ContactUs />}></Route>
              <Route path="/trafik-akisi" element={<TrafficFlow setShowAppFooter={setShowAppFooter} setShowAppNavbar={setShowAppNavbar} />}></Route>
              <Route path="*" element={<ErrorPage />}></Route>
            </Routes>
          </Container>
        </main>
        <TopButton lenis={lenis} lenisStop={lenisStop} lenisStart={lenisStart} routes={routes} animationFrameId={animationFrameId} />
        <Footer routes={routes} showAppFooter={showAppFooter} />
        <Toaster position="top-center" toastOptions={{
          duration: 3750,
          style: {
            fontFamily: '"Poppins", sans-serif',
            fontSize: "16px"
          }
        }}
        />
      </Router>
    </div>
  );
}

export default App;